import React from 'react';
import { func } from 'prop-types';

import useGameStore, { BINGO, JACKPOT, MULTI_JACKPOT } from 'stores/game';

import Modal from 'components/Modal/Modal';

import BingoRiveAnimation from './BingoRiveAnimation/BingoRiveAnimation';

import styles from './BingoPrizeNotification.module.scss';

const prizeNotificationSelector = (state) => state.prizeNotification;

// eslint-disable-next-line react/prop-types
function BingoPrizeNotification({ onClose }) {
  const prizeNotification = useGameStore(prizeNotificationSelector);

  const isBingo = prizeNotification === BINGO;
  const isJackpot = prizeNotification === JACKPOT;
  const isMultiJackpot = prizeNotification === MULTI_JACKPOT;

  return (
    <Modal willFill isPrizeModal>
      <div className={styles.wrapper}>
        {isBingo && <BingoRiveAnimation animation="bingo" />}
        {isJackpot && <BingoRiveAnimation animation="jackpot" />}
        {isMultiJackpot && <BingoRiveAnimation animation="jackpot-shared" />}
      </div>
      <button
        onClick={onClose}
        type="button"
        className={styles.overlayButton}
        aria-hidden
      />
    </Modal>
  );
}

BingoPrizeNotification.propTypes = {
  onClose: func.isRequired,
};

export default BingoPrizeNotification;
